export const common = {
  type: {
    messaging: {
      title: 'Сообщения',
      sms: 'SMS',
      hlr: 'HLR'
    },
    voice: {
      title: 'Голосовая связь',
      inc_voice: 'Входящие вызовы',
      out_voice: 'Исходящие вызовы',
      pbx_inc_voice: 'АТС Входящие вызовы',
      pbx_out_voice: 'АТС Исходящие вызовы',
      autocaller_inc_voice: 'Автоинформатор Входящие вызовы',
      autocaller_out_voice: 'Автоинформатор Исходящие вызовы',
      predictive_inc_voice: 'Предиктивный обзвон Входящие вызовы',
      predictive_out_voice: 'Предиктивный обзвон Исходящие вызовы',
      amo_out_voice: 'Виджет CRM Исходящие вызовы',
      amo_inc_voice: 'Виджет CRM Входящие вызовы',
      kommo_inc_voice: 'Виджет Kommo CRM входящие звонки',
      kommo_out_voice: 'Виджет Kommo CRM исходящие звонки'
    },
    number_verification: {
      title: 'Верификация номеров',
      sms_number_verification: 'Верификация по СМС',
      call_number_verification: 'Верификация по исходящему звонку',
      phone_number_verification: 'Верификация по входящему звонку',
      voice_number_verification: 'Верификация по входящему звонку с\u00A0диктовкой кода'
    }
  },

  info: {
    no_rates: 'Тарифы отсутствуют',
    billing_terms_tooltip:
      '<b>FT (FreeTime)</b> - это время в секундах от начала звонка, в течение которого он не тарифицируется.<br/><b>MC (Minimum Commitment)</b> - это минимальный интервал начальной тарификации. То есть время, после окончания FT, за которое спишутся деньги, даже если звонок был короче этого времени.<br/><b>CI (Commitment Interval)</b> - это основной интервал тарификации. То есть интервал, по которому будет тарифицироваться звонок после FT и MC. Если CI=0, то звонок будет тарифицироваться согласно MC до самого конца.'
  },

  field: {
    name: 'Наименование',
    mcc: 'MCC',
    mnc: 'MNC',
    code: 'Код',
    country: 'Страна',
    provider: 'Провайдер мобильного сервиса',
    price: 'Цена',
    date_start: 'Действителен c',
    date_end: 'Действителено до',
    trunk: 'Транк',
    billing_terms: 'Тарификация'
  }
};
